import { Col, Row } from 'antd';
import * as React from 'react';

type Props = {}

const PasswordResetCompleteCard: React.FC<Props> = ({ }) => {

    return (<>
        <Row justify="center">
            <Col>
                <p>Account password has been reset successfully. You may now use the new password to signin to your account.</p>
                <a href="/signin">Click here to go to signin page</a>
            </Col>
        </Row>
    </>
    );
}

export default PasswordResetCompleteCard;
